var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-stars"},[_vm._l((_vm.stars),function(star){return _c('span',{class:star.class})}),_c('span',{staticClass:"ada-tooltip"},[_vm._v(_vm._s(_vm.rating)+" out of 5 stars")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }